import React from "react";
import { useShop } from "../context/ShopContext";
import "./Cart.css";
import { Link } from "react-router-dom";
import BackButton from "../components/BackButton";


function Cart() {


const {

cart,

removeFromCart,

increaseQty,

decreaseQty

}=useShop();




const total = cart.reduce(

(sum,item)=>

sum + Number(item.price) * item.quantity,

0

);






return (

<div className="cart-page">



<BackButton />



<h1>

Shopping Cart 🛒

</h1>





{

cart.length===0 ? (



<div className="empty-cart">


<h2>

Your cart is empty

</h2>


<p>

Add cute products 🤍

</p>



</div>



)

:

(



<div className="cart-container">





{

cart.map(item=>(



<div

className="cart-card"

key={

item.id + item.color + item.size

}

>





<img

src={item.images?.[0] || "/no-image.png"}

alt={item.name}

/>







<div className="cart-info">





<h2>

{item.name}

</h2>





<p>
Price: ${item.price}
</p>


{
item.color && (

<div className="option">

🎨 Color:

<span
className="cart-color"
style={{
background:item.color
}}
></span>

</div>

)

}



{
item.size && (

<div className="option">

📏 Size:

<span className="cart-size">

{item.size}

</span>

</div>

)

}







{/* COLOR */}

{

item.color && (

<p>

🎨 Color: {item.color}

</p>

)

}







{/* SIZE */}

{

item.size && (

<p>

📏 Size: {item.size}

</p>

)

}








<div className="quantity">





<button

onClick={()=>decreaseQty(

item.id,

item.color,

item.size

)}

>

-

</button>







<span>

{item.quantity}

</span>







<button

onClick={()=>increaseQty(

item.id,

item.color,

item.size

)}

>

+

</button>






</div>







<button

className="remove-btn"

onClick={()=>removeFromCart(

item.id,

item.color,

item.size

)}

>


Remove 🗑️


</button>






</div>





</div>





))

}







<h2>

Total: ${total}

</h2>







<Link to="/checkout">


<button className="checkout-btn">

Checkout

</button>



</Link>







</div>



)

}





</div>


);


}



export default Cart;